export default __webpack_public_path__ + "static/media/pause.cea19016.svg";